import React from "react";
import {observer} from "mobx-react";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const KickedOutDialog = observer(() => {
    const {modalStore, generalStore} = useStores();


    async function onClose() {
        await generalStore.logOut();
        modalStore.isKickedOutModalOpen = false;
        modalStore.resetModalData();
    }

    return (
        <GeneralDialog
            openControl='isKickedOutModalOpen'
            className='delete-dialog kicked-out-modal'
            onEnter={null}
            noCancel
            disableBackdropClick
            disableEscapeKeyDown

            title={generalStore.translate('disconnected')}
            body={
                <React.Fragment>
                    {generalStore.translate('youDisconnectedThisSessionRemotely')}. {generalStore.translate('itWasNotYou')}?
                    <a href='mailto:support@frontline.io' target='_blank'
                       rel='noreferrer'>{generalStore.translate('tellUs')}</a>
                </React.Fragment>
            }
            isConfirmDisabled={false}
            onConfirm={onClose}
            confirmText={generalStore.translate('confirm')}
        />
    );
});

export default KickedOutDialog;
